// extracted by mini-css-extract-plugin
export default {"contact":"WhereToBuy_contact__BuGR2","shop":"WhereToBuy_shop__ffEkP","text_warning":"WhereToBuy_text_warning__ck07U"};